// Single source of truth for the credit economy. Server (server/utils) and
// client (utils) both re-export from here so the numbers can never drift.
//
// Rebased x2.5 on 2026-10 (2000 -> 5000 monthly, AI costs x2.5) so credits
// bought as packs (10,000 / $5, unchanged) are worth half a subscription
// credit instead of a fifth. API calls still cost 1 credit.
//
// The monthly allowance is duplicated in SQL as `v_monthly` inside
// public.credits_refresh (see supabase/migrations) - keep both in sync.

export const MONTHLY_LIMIT = 5000;
export const BONUS_LIMIT = 10000;
export const BONUS_LIMIT_PRICE = 5;

// Fixed per-job feature costs.
export const FEATURE_COSTS = {
  summarize: 25,
  translate: 50,
  analyze_comments: 25,
  ai_perspective: 25,
  translate_subtitle_extension: 50,
};

// AI translate rate: FEATURE_COSTS[feature] credits per this many subtitle
// lines (50 per 400 = 1 credit per 8 lines), billed per line with a minimum of
// one FEATURE_COSTS[feature] per job. Also the chunk size jobs are split into.
export const TRANSLATE_LINES_PER_UNIT = 400;

/** Credits for `lineCount` lines at the per-line rate, without the minimum. */
export const translateLineCredits = (lineCount: number, unitCost: number) =>
  Math.ceil((Math.max(0, lineCount) * unitCost) / TRANSLATE_LINES_PER_UNIT);

/** Price of a translate job: per-line rate, never less than `unitCost`. */
export const translateCredits = (lineCount: number, unitCost: number) =>
  Math.max(unitCost, translateLineCredits(lineCount, unitCost));

/** Lines a charge of `credits` pays for at the per-line rate. */
export const translateLinesForCredits = (credits: number, unitCost: number) =>
  Math.floor((Math.max(0, credits) * TRANSLATE_LINES_PER_UNIT) / unitCost);

// Summarize / perspective without a transcript make Gemini watch the video
// itself, which costs per minute of media instead of per job.
export const WATCH_VIDEO_CREDITS_PER_MINUTE = 3;
export const WATCH_VIDEO_MAX_MINUTES = 180;

// Video/audio to subtitle pipeline, per rounded-up minute of source media.
export const SUBTITLE_CREDITS_PER_MINUTE = 5;
